import React from "react";
import banner from "../../images/me/banner.webp";
import { Kicker } from "./Surface";

/**
 * One photograph, once.
 *
 * The hero is deliberately typographic — a face is the least interesting thing
 * a developer can open with, and the headline needs the whole screen. But a
 * portfolio with no human in it anywhere reads like a template, so there is
 * exactly one band, low on the page, where the reader has already had the
 * argument and can afford the aside.
 *
 * The height tracks the source. The photo is 1170×293, so anything taller than
 * about a quarter of its width makes `object-cover` throw most of the frame
 * away and enlarge what is left — which is how a wide, sharp banner turns into
 * a soft close-up of somebody's shoulder.
 *
 * It is desaturated and sat under a scrim that fades left to right: the words
 * start at the left edge and he is standing on the right, so each gets the half
 * it needs. The photo is warm and blue, the site is neither.
 */
export default function Band() {
  return (
    <figure className="relative isolate m-0 h-[200px] overflow-hidden rounded-brand-lg border border-edge desk:h-[280px]">
      <img
        src={banner}
        alt="Casper tussen de vrijwilligers op een evenement"
        loading="lazy"
        width="1170"
        height="293"
        className="absolute inset-0 -z-20 size-full object-cover object-[62%_38%] saturate-[0.5]"
      />

      {/* Fixed void, not `--c-bg`. The caption is chalk in both themes, so a
          scrim that follows the theme would fade to paper under white type in
          daylight. This one panel stays night at every point of the dial. */}
      <span
        aria-hidden
        className="pointer-events-none absolute inset-0 -z-10 [background:linear-gradient(90deg,var(--void)_0%,rgb(10_11_9/0.8)_38%,rgb(10_11_9/0.28)_72%,transparent_100%)]"
      />

      <figcaption className="relative flex h-full max-w-[40ch] flex-col justify-center px-7 desk:px-12">
        <Kicker className="!mb-2.5 !text-chalk/55">Buiten de code</Kicker>
        <p className="font-display text-[clamp(16px,2vw,25px)] leading-[1.2] font-medium tracking-[-0.045em] !text-chalk">
          De meeste van deze sites begonnen bij een vereniging waar ik zelf voor rondliep.
        </p>
      </figcaption>
    </figure>
  );
}
